import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAddModel = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 60 60",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M29.47 21h1.054v18h-1.053zM21 30.53v-1.06h18v1.06z" })
});
export default SvgAddModel;
